import { useState } from "react";
import SectionHeader from "./SectionHeader";

const FAQS = [
  {
    q: "九色吃瓜到底是什么？",
    a: "九色吃瓜是一个面向年轻用户的娱乐话题同好聚集地，把散落在各个平台的追热点需求，组织进同一个圈子里：新瓜预告、话题复盘、后续进度同步都在这里，方便大家一起吃瓜蹲料。",
  },
  {
    q: "加入社群收费吗？",
    a: "普通进群以页面上的申请表单为准。请留意：任何以“入群费”“审核费”“解锁会员”等名义私下索要转账或充值的情况都不符合规范，遇到请务必留个心眼，谨防上当。",
  },
  {
    q: "申请后多久能进群？",
    a: "管理员一般会在核对完你的入群备注与意向栏目后尽快发送邀请，通常很快就能跟上节奏。高峰期人数较多时可能会稍慢一点，请耐心等待通知。",
  },
  {
    q: "群里有吵架引战吗？",
    a: "群内置顶公约以友好交流为前提：尊重不同观点、理性讨论、隐私不过度挖掘。对于引战、传谣或恶意攻击等行为，管理员会按公约及时提醒和处理，把氛围守好。",
  },
  {
    q: "只看不聊、潜水围观可以吗？",
    a: "完全可以。蹲料、潜水、偶尔冒泡都欢迎，进群不强制发言。想深入了解某个话题时，随时可以在群里提问，总会有人愿意接你。",
  },
  {
    q: "网上的消息到底怎么分辨真假？",
    a: "可以参考“理性吃瓜”栏目的内容：学会看信源、对照多方说法、警惕只有情绪没有依据的说法。遇到拿不准的信息，先求证再转发，吃瓜也要带点脑子。",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: f.a,
    },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <section id="faq" className="scroll-mt-16 bg-background-100 py-16 md:py-20">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
            <div>
              <SectionHeader
                eyebrow="常见问题"
                title="入群前你可能想问的"
                desc="关于九色吃瓜、入群方式和群内氛围，把最常见的疑问放在这里。没找到答案，也可以直接给我们留言。"
                align="left"
              />
              <a
                href="#joinform"
                className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
              >
                还有疑问？直接申请入群
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>

            <div className="space-y-3">
              {FAQS.map((item, idx) => {
                const open = openIndex === idx;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                      open ? "border-primary-200" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : idx)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">{item.q}</span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-in-out ${
                        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}